import { Card, Progress, Row, Col } from 'antd-v4';
import { HeartOutlined } from '@ant-design/icons';
import { ICreditMap, IPlan } from '@leedpulse-monorepo/interfaces';
import { UserType } from '@leedpulse-monorepo/enums';

const LeadsCard = ({ credits, plan, userType }: { credits: ICreditMap, plan: IPlan, userType: UserType }) => {
  // Handle case where credits or plan is not yet loaded
  const contactsCredits = credits?.contacts ?? 0;
  const planContactsCredits = plan?.credits?.contacts ?? 1; // Default to 1 to avoid division by zero

  let percent = 0;
  if (plan?.id !== "c" && planContactsCredits > 0) {
    percent = (contactsCredits / planContactsCredits) * 100;
  }

  return (

    <Card className="hp-border-radius-lg hp-dashboard-feature-card hp-cursor-pointer">
      <Row>
        {/* LEFT SECTION */}
        <Col span={12}>
          {/* Display credits icon */}
          <div
            className="hp-d-flex-full-center hp-dashboard-feature-card-icon hp-border-radius-lg hp-bg-black-20 hp-bg-dark-85"
            style={{ width: 48, height: 48 }}
          >
            <HeartOutlined className='hp-text-color-primary-1 hp-text-color-primary-2' style={{ fontSize: '24px' }} />
          </div>

          {/* Display credits title */}
          <div className="hp-d-flex hp-mt-12">
            <span className="h5 hp-mb-0 hp-d-block hp-text-color-black-bg hp-text-uppercase hp-text-color-dark-0 hp-font-weight-500 hp-mr-4">
              CREDITS
            </span>
          </div>

          {/* Display credits number */}
          <span
            className={`hp-text-color-dark-0 hp-d-block hp-mt-12 hp-mb-8 h1${userType === 'user' ? ' blur' : ''}`}
            style={{
              color: "#6737ff",
            }}
          >
            {contactsCredits}
          </span>
        </Col>

        {/* RIGHT SECTION (optional) */}
        {/* Display donut chart if plan is a renewable monthly plan */}
        {plan?.id !== "c" && (
          <Col span={12} className='hp-d-flex-full-center hp-align-items-center'>
            <Progress
              type='circle'
              percent={percent}
              showInfo={true}
              strokeColor={{
                '0%': '#7244FF',
                '50%': '#9B74FF',
                '100%': '#C5A5FF',
              }}
              style={{ width: '100%' }}
            />
          </Col>
        )}

        </Row>
    </Card>
  );
};

export default LeadsCard;
